import { Component, Input } from '@angular/core';
import { AboutUsStoryItemConfig } from 'src/app/interfaces/pageConfig';

@Component({
  selector: 'app-story-timeline-item',
  templateUrl: './story-timeline-item.component.html',
  styleUrl: './story-timeline-item.component.scss'
})
export class StoryTimelineItemComponent {
  @Input() item!: AboutUsStoryItemConfig;
}
